import React, { useEffect, useState } from "react";
import PaymentItems from "../paymentItems/paymentItems";
import '../../css/homepage.css'

const AddEmployee = ({ values }) => {
  // wallet
  const [notifications, setNotifications] = useState([]);

  // create a new wallet address
  const createNewWallet = async (e) => {
    e.preventDefault();
  };

  // useeffect
  useEffect(() => {
    setNotifications(values?.notifications);
  }, []);
  return (
    <div className="lg:px-12">
      <div>
        <p className="text-xl font-semibold py-2 title">Notifications</p>
      </div>
      <div className="grid grid-cols-5 space-x-3 mx-2">
        <div className="col-span-5 bg-[#434242] rounded shadow-xl px-6 py-3 h-[80vh] overflow-y-scroll">
          <div className="py-2">
            <p className="text-center font-semibold text-lg text-white">
              Notifications
            </p>
          </div>
          <div>
            <div className="lg:grid grid-cols-7 text-white hidden">
              <p className="col-span-1">Profile</p>
              <p className="col-span-1">Sender Name</p>
              <p className="col-span-2">Sender Address</p>
              <p className="col-span-3">Details</p>
            </div>
            <>
              {notifications?.map((item, i) => (
                <PaymentItems key={i} wallet={item} />
              ))}
            </>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddEmployee;
